<template>
  <div v-show="showMenu" class="float-menu">
    <a href="userCenter/my/user/user/edit/view"
      ><div class="float-menu-item">帳號編輯</div></a
    >
    <a href="userCenter/my/user/notification/list/view"
      ><div class="float-menu-item">通知列表</div></a
    >
    <a href="userCenter/my/myCourse/favoriteCourse/list/view"
      ><div class="float-menu-item">喜愛課程</div></a
    >
    <a href="userCenter/my/myCourse/myCourse/list/view"
      ><div class="float-menu-item">實體課程</div></a
    >
    <a href="userCenter/my/myCourse/myOnlineCourse/list/view"
      ><div class="float-menu-item">線上課程</div></a
    >
    <a href="userCenter/my/courseOrder/courseOrder/list/view"
      ><div class="float-menu-item">課程訂單</div></a
    >
    <a href="userCenter/my/order/order/list/view"
      ><div class="float-menu-item last">產品訂單</div></a
    >
    <a href="user/logout"
      ><div class="float-menu-item login-out">登出</div></a
    >
  </div>
</template>

<script>
export default {
  props: ['showMenu'],
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
